import type { ReactNode, } from 'react'

import { Header } from '@/components/layout'
import { KeyboardShortcutsOverlay } from '@/components/ui'

interface MixLayoutProps {
  header?: ReactNode
  children: ReactNode
}

export default function MixLayout({ children }: MixLayoutProps) {

  return (
    <div className="flex flex-col min-h-screen min-h-dvh bg-background font-sans antialiased safe-area-padding">
      <Header />
      <main className="flex-1 flex flex-col pt-16 py-4">
        <div className="w-full max-w-[768px] mx-auto flex flex-col flex-1 min-h-0 pt-1 z-10">
          {children}
        </div>
      </main>
      <KeyboardShortcutsOverlay />
    </div>
  )
}
